import { useLayoutEffect, useRef, EffectCallback } from 'react';

const useWillMount = (fn: EffectCallback) => {
  const onWillMountRef = useRef(fn);
  useLayoutEffect(() => onWillMountRef.current?.(), []);
};

export default useWillMount;
